import { toast } from "sonner";

import { BUTTON_STYLE, TITLE_STYLE, toastStyles } from "./ToastCustom";

const getToastDescription = (message: string, title?: string) => (
  <>
    {title && <p className={TITLE_STYLE}>{title}</p>}
    <p>{message}</p>
  </>
);

export const toastSuccess = (message: string, title?: string) =>
  toast.success("", {
    description: getToastDescription(message, title),
    style: toastStyles.success,
  });

export const toastError = (
  message: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: (a?: any) => void,
  title?: string
) => {
  const id = toast.error("", {
    description: getToastDescription(message, title),
    style: toastStyles.error,
    action: (
      <button
        onClick={() => {
          action();
          toast.dismiss(id);
        }}
        className={BUTTON_STYLE}
      >
        Try again
      </button>
    ),
  });
};

export const toastWarning = (message: string, title?: string) => {
  const id = toast.warning("", {
    description: getToastDescription(message, title),
    style: toastStyles.warning,
    action: (
      <button onClick={() => toast.dismiss(id)} className={BUTTON_STYLE}>
        ok
      </button>
    ),
  });
};
